import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/expert_report/person.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c5cb4942")

_pushScopeId("data-v-c5cb4942")
const _hoisted_1 = {
  key: 0,
  class: "expertreport"
}
const _hoisted_2 = { class: "titlebox" }
const _hoisted_3 = { class: "psersonname" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "exportname" }, "健康状态测评分析报告", -1)
const _hoisted_5 = { class: "datebox" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "card card-shadow mt0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title bgblue" }, "五藏测评", -1)
const _hoisted_9 = { class: "scorebox" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  })
], -1)
const _hoisted_11 = { class: "score" }
const _hoisted_12 = { class: "item-name" }
const _hoisted_13 = { class: "num-line" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 综合评分：")
const _hoisted_15 = { class: "subtitle" }
const _hoisted_16 = { class: "card card-shadow" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-t" }, "24小时脉搏波变换图", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-c" }, "该图表达了用户的24小时脉搏波变化情况。蓝线表示心肌收缩力，红线表示外周血管阻力。", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-t" }, "24小时心率分布图", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-c" }, "该图表达了用户的24小时心率实时分布状况。横轴表达了心率变化的发生时间，纵轴表达了心率的高低。绿色部分反映用户处于静息睡眠状态，红色部分反映用户处于运动亢奋状态，蓝色部分反映用户处于一般清醒状态。在觉醒过程中，心率越低，表示用户在该段时间内月放送，精神不振。在觉醒过程中，心率越高，表示用户在该段时间内越兴奋，精神亢奋。", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-t" }, "24小时Poincare散点图", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-c" }, "该图表达了用户的24小时Poincare分布状况。", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-t" }, "24小时体动分布图", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "txt report-tip-c" }, "该图表达了用户的24小时体动分布状况。", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "gap" }, null, -1)
const _hoisted_33 = { class: "footer clearfix" }
const _hoisted_34 = {
  key: 1,
  class: "skeletonbox"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")
  const _component_ExpertSubTitleItem = _resolveComponent("ExpertSubTitleItem")
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")
  const _component_van_collapse = _resolveComponent("van-collapse")
  const _component_PersonInfoToast = _resolveComponent("PersonInfoToast")
  const _component_Disclaimers = _resolveComponent("Disclaimers")
  const _component_van_skeleton = _resolveComponent("van-skeleton")

  return (_ctx.report && _ctx.memberInfo)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.memberInfo.userName), 1),
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.report.reportDate.substring(0, 10)) + " ~ " + _toDisplayString(_ctx.report.createTime.substring(0, 10)), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _createVNode("div", _hoisted_12, _toDisplayString(item.name + '测评'), 1),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_ScoreNum, {
                      score: item.score
                    }, null, 8, ["score"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "card card-shadow",
            key: index
          }, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_15, _toDisplayString(item.name  +'综合评分'), 1)
            ]),
            _createVNode(_component_ExpertSubTitleItem, { data: item }, null, 8, ["data"])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_van_collapse, {
            class: "",
            modelValue: _ctx.panel4,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.panel4 = $event))
          }, {
            default: _withId(() => [
              _createVNode(_component_van_collapse_item, {
                title: "数据图",
                name: "1"
              }, {
                default: _withId(() => [
                  _createVNode("img", {
                    src: _ctx.report.pulseCurveUrl,
                    alt: "",
                    srcset: ""
                  }, null, 8, ["src"]),
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode("img", {
                    src: _ctx.report.ecgCurveUrl,
                    alt: "",
                    srcset: ""
                  }, null, 8, ["src"]),
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _createVNode("img", {
                    src: _ctx.report.poincareUrl,
                    alt: "",
                    srcset: ""
                  }, null, 8, ["src"]),
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28,
                  _createVNode("img", {
                    src: _ctx.report.pmCurveUrl,
                    alt: "",
                    srcset: ""
                  }, null, 8, ["src"]),
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _hoisted_32
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_33, [
          true
            ? (_openBlock(), _createBlock(_component_PersonInfoToast, {
                key: 0,
                title: "健康报告专家授权：",
                person: "王义国"
              }))
            : (_openBlock(), _createBlock(_component_PersonInfoToast, {
                key: 1,
                title: "健康报告专家授权：",
                person: "张启明"
              }))
        ]),
        _createVNode(_component_Disclaimers, { padding: "0 0.4rem 0.4rem" })
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_34, [
        _createVNode(_component_van_skeleton, {
          title: "",
          avatar: "",
          row: 1
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        })
      ]))
})